import React from 'react';

import './styles.css';


const Component = ({ placeholder, onChange, rows }) => {
  return (
    <textarea
      rows={rows || "7"}
      className="rounded_textArea"
      placeholder={placeholder}
      onChange={onChange}
      onFocus={onChange}
    />
  );
};

Component.displayName = 'RoundTextArea';

export default Component;



// WEBPACK FOOTER //
// ./src/components/RoundTextArea/index.js